<template>
  <div
    class="dash_icon"
    :title="title"
    :style="{ backgroundImage: `url(${currentBackground})` }"
  ></div>
</template>
<script>


export default {
  props: {
    title: { type: String, default: "" },
    isActive: { type: Boolean, default: false },
    defaultIcon: { type: String, default: "ic_houwudeng.png" },
    activeIcon: { type: String, default: "ic_houwudeng_active.png" },
  },
  data() {
    return {};
  },
  computed: {
    currentBackground() {
      return require(`@/assets/images/${
        this.isActive ? this.activeIcon : this.defaultIcon
      }`);
    },
  },
  methods: {},
};
</script>
<style scoped>
.dash_icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-size: cover;
  float: left;
  cursor: pointer;
  margin-right: 20px;
}
</style>
